// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"_8482f5a"};